var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShapedBackgroundLanding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    viewBox: "0 0 375 450",
    height: 600,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.293 178.398c13.41 0 24.34-11.043 24.34-24.742h2.285-2.285c0-13.695-10.93-24.742-24.34-24.742v-2.285 2.285c-13.41 0-24.34 11.047-24.34 24.742h-2.285 2.285c0 13.7 10.93 24.742 24.34 24.742v2.286-2.286m0 4.575c-16 0-28.91-13.16-28.91-29.317 0-16.156 12.91-29.312 28.91-29.312s28.91 13.156 28.91 29.312-12.91 29.317-28.91 29.317zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.258 17.129H50.93v36.21H15.258zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.824 15.695h38.54v39.078h-38.54zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.094 51.727c8.937 0 16.222-7.364 16.222-16.493h1.524-1.524c0-9.129-7.285-16.492-16.222-16.492V17.22v1.523c-8.938 0-16.223 7.363-16.223 16.492h-1.523 1.523c0 9.13 7.285 16.493 16.223 16.493v1.523-1.523m0 3.046c-10.664 0-19.27-8.77-19.27-19.539 0-10.77 8.606-19.539 19.27-19.539s19.27 8.77 19.27 19.54c0 10.769-8.606 19.538-19.27 19.538zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.535 126.496H67v54.324H13.535zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.293 180.684c14.707 0 26.625-12.098 26.625-27.028 0-14.93-11.918-27.027-26.625-27.027-14.703 0-26.625 12.098-26.625 27.027 0 14.93 11.922 27.028 26.625 27.028"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.383 124.344h57.82v58.629h-57.82zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.094 53.25c9.8 0 17.746-8.066 17.746-18.016 0-9.949-7.945-18.015-17.746-18.015-9.801 0-17.746 8.066-17.746 18.015 0 9.95 7.945 18.016 17.746 18.016"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326 29.578h48.992V41H326zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m374.992 31.29-8.012 6.78-10.039-8.492-10.039 8.492-10.043-8.492-10.843 9.176 1.613 1.46 9.23-7.812 10.043 8.493 10.04-8.493 10.038 8.493 8.012-6.782zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326 44.426h48.996v12.59H326zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m374.996 46.332-8.016 7.543-10.039-9.45-10.039 9.45-10.039-9.45-10.843 10.208 1.613 1.625 9.23-8.692 10.04 9.45 10.038-9.45 10.04 9.45 8.015-7.547zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 153.652h44.719v12.59H0zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-4.36 164.336 8.016-7.543 10.04 9.45 10.038-9.45 10.04 9.45 10.843-10.208-1.613-1.625-9.23 8.692-10.04-9.45-10.039 9.45-10.039-9.45-8.015 7.547zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350.512 142.785H375v149.2h-24.488zm0 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.926 14.8h40.336v40.872H12.926zm0 0"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7bdec1",
    d: "M12.926 14.8h40.336v40.872H12.926zm0 0"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7bdec1",
    d: "M10.04 123h60.507v61.316H10.039zm0 0"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7bdec1",
    d: "M10.04 123h60.507v61.316H10.039zm0 0"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f8d04f",
    d: "M374.992 29.578v11.317H326.06V29.578zm0 0"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#l)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f8d04f",
    d: "M374.996 44.426v12.59H326.06v-12.59zm0 0"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#n)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-4.36 166.242v-12.59h48.938v12.59zm0 0"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#o)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f3afad",
    d: "M350.512 142.785h96.43V291.95h-96.43zm0 0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapedBackgroundLanding);
export default __webpack_public_path__ + "static/media/shaped_background_landing.b180ba86a53d5eb430bb71107844d813.svg";
export { ForwardRef as ReactComponent };